module.exports = __webpack_public_path__ + "static/media/password.b25b5f85.png";